import { useSelector } from "react-redux";

import { SubscribeCustomerToBonusCardRequest } from "@/api/hooks/customerService.types";
import {
    BonusCardRequest,
    RequestBonusCardAddress,
    RequestBonusCardCustomerModel
} from "@/components/Account/BonusCardRequest/bonusCardRequest.component";
import { useAddressValidationContext } from "@/components/Address/AddressValidation/context/addressValidation.context";
import { Modal } from "@/components/General/Modal/modal";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    isLoadingRequest: boolean;
    onSubmit: (
        formValues: SubscribeCustomerToBonusCardRequest
    ) => Promise<void>;
    address?: RequestBonusCardAddress;
    customer: RequestBonusCardCustomerModel;
};
const FORM_ID = "bonusCardRequestModal";

const BonusCardRequestModal = ({
    isOpen,
    isLoadingRequest,
    onClose,
    onSubmit,
    address,
    customer
}: Props) => {
    const { isValidating } = useAddressValidationContext();
    const isLoadingCustomer = useSelector(CustomerSelectors.isLoading);
    const cart = useSelector(CartSelectors.getCart);
    const { t } = useGranite();

    return (
        <Modal
            modalType={ModalType.BonusCardRequest}
            title={t("general.bonusCardRequest.modal.title")}
            formId={"bonusCardRequestModal"}
            size={"lg"}
            open={isOpen}
            setOpen={onClose}
            isLoading={isValidating || isLoadingCustomer || isLoadingRequest}
            confirmButtonText={t("general.bonusCardRequest.modal.button.label")}
        >
            <BonusCardRequest
                isLoading={isLoadingRequest}
                customer={customer}
                fallbackStoreId={cart?.shopId}
                address={address}
                formId={FORM_ID}
                onSubmit={onSubmit}
            />
        </Modal>
    );
};

export { BonusCardRequestModal };
